import {faEdit, faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useTranslation} from 'react-i18next'
import {createUseStyles} from 'react-jss'
import {Colors} from "../../constants/colors"
import {PayDeviation} from '../../redux/types'
import ListItemCard from "../ListItemCard"
import Pagination from '../Pagination'

interface Props {
  deviationsOnPage: PayDeviation[]
  pageIndex: number
  pageSize: number
  totalCount: number
  onDeviationClick: (deviation: PayDeviation) => void
  onEditClick: (deviation: PayDeviation) => void
  onDeleteClick: (deviation: PayDeviation) => void
  onPageChange: (pageIndex: number) => void
}

const PayDeviationList = ({
                            deviationsOnPage,
                            pageIndex,
                            pageSize,
                            totalCount,
                            onDeviationClick,
                            onEditClick,
                            onDeleteClick,
                            onPageChange
                          }: Props) => {
  const {t} = useTranslation(['common', 'deviations']);
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <ListItemCard className={styles.listItemContainer}>
        <div className={styles.nameCellContainer}>
          <strong>{t('employee', {ns: 'common'})}</strong>
        </div>
        <div className={styles.defaultCellContainer}>
          <strong>{t('date', {ns: 'common'})}</strong>
        </div>
        <div className={styles.defaultCellContainer}>
          <strong>{t('description', {ns: 'deviations'})}</strong>
        </div>
        <div className={`${styles.defaultCellContainer}`}>
          <strong>{t('grossAmount', {ns: 'deviations'})}</strong>
        </div>
        <div className={styles.buttonContainer}>

        </div>
      </ListItemCard>
    )
  }

  const renderListItems = () => {
    return deviationsOnPage?.map((deviation, index) => {
      return (
        <ListItemCard key={`deviation_${index}`} className={styles.listItemContainer} index={index} onClick={() => onDeviationClick(deviation)}>
          <div className={styles.nameCellContainer} title={deviation.employee.identificationNumber}>
            {deviation.employee.name}
          </div>
          <div className={`${styles.defaultCellContainer}`}>
            {deviation.date}
          </div>
          <div className={`${styles.defaultCellContainer}`}>
            {deviation.description}
          </div>
          <div className={`${styles.defaultCellContainer}`}>
            {deviation.grossValue.amount.toLocaleString('sv-SE', {minimumFractionDigits: 2})} {deviation.grossValue.currencyCode.toUpperCase()}
          </div>
          <div className={styles.buttonContainer}>
            <div>
              <FontAwesomeIcon
                className={styles.button}
                icon={faEdit}
                color={Colors.gray1}
                title={t('edit', {ns: 'common'})}
                onClick={(event) => {
                  event.stopPropagation()
                  onEditClick && onEditClick(deviation)
                }}
              />
            </div>
            <div>
              <FontAwesomeIcon
                className={styles.button}
                icon={faTrashAlt}
                color={Colors.gray1}
                title={t('delete', {ns: 'common'})}
                onClick={(event) => {
                  event.stopPropagation()
                  onDeleteClick && onDeleteClick(deviation)
                }}
              />
            </div>
          </div>
        </ListItemCard>
      )
    })
  }

  return (
    <div>
      <div className={styles.container}>
        {renderHeader()}
        {renderListItems()}
      </div>
      <div className={styles.pagination}>
        <Pagination
          pageIndex={pageIndex}
          itemCount={totalCount}
          pageSize={pageSize}
          siblingCount={1}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}

export default PayDeviationList

const useStyles = createUseStyles({
  container: {
    width: '100%',
    overflowX: 'auto',
  },
  listItemContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between'
  },
  defaultCellContainer: {
    flexShrink: 0,
    width: 130
  },
  nameCellContainer: {
    flexShrink: 0,
    width: 200
  },
  buttonContainer: {
    display: 'flex',
    width: 80,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignContent: 'center',
    paddingLeft: 0
  },
  button: {
    marginRight: 15,
    transition: '0.4s',
    '&:hover': {
      color: Colors.euro_600,
      cursor: 'pointer',
    }
  },
  pagination: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center'
  }
})
